import { useLocation } from 'react-router';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { QuickActionsMenu } from 'modules/quickActionsMenu';
import { QuickActionsMenuContextProvider } from 'modules/quickActionsMenu/contexts';
import { selectIsMissionControlHomepageFeatureFlagOn } from 'core/userContext/selectors';
import { LogoVariants } from 'ui/logo';

import { ACTIVE_LOGO_CLASS_NAME, NAVBAR_VARIANTS } from './constants';
import { NavbarLinks } from './components/NavbarLinks';
import { NavbarMenus } from './components/NavbarMenus';
import { NAVBAR_LOGO } from './components/NavLogo';
import { HamburgerMenuTrigger } from './components/HamburgerMenuTrigger';
import {
  NavbarContainer,
  StyledNavLogo,
  HamburgerMenuTriggerContainer,
  NavbarLinksContainer,
  NavbarMenuContainer,
  LogoContainer,
} from './Navbar.styled';
import type { NavbarVariant } from './types';

export const NAVBAR_IDS = {
  id: 'navbar',
  linksId: 'navbar-links-container',
  logoId: 'navbar-logo',
  menusId: 'navbar-menus-container',
  triggerId: 'navbar-trigger',
};

const { id, linksId, logoId, menusId, triggerId } = NAVBAR_IDS;

export const Navbar = ({ variant = NAVBAR_VARIANTS.DEFAULT }: { variant?: NavbarVariant }) => {
  const { pathname } = useLocation();
  const isHomepageEnabled = useSelector(selectIsMissionControlHomepageFeatureFlagOn);

  const isNovaVariant = variant === NAVBAR_VARIANTS.NOVA;
  const isHomepage = pathname === NAVBAR_LOGO.homeUrl;
  const isHomepageSelected = isHomepage && isNovaVariant;

  const MenusWrapper =
    isHomepageSelected && isHomepageEnabled ? Fragment : QuickActionsMenuContextProvider;

  return (
    <NavbarContainer id={id} data-test={id} data-variant={variant}>
      <LogoContainer>
        <StyledNavLogo
          id={logoId}
          data-test={logoId}
          variant={isNovaVariant ? LogoVariants.DIAMOND_BORDERED : undefined}
          className={isHomepageSelected ? ACTIVE_LOGO_CLASS_NAME : ''}
        />
      </LogoContainer>

      <HamburgerMenuTriggerContainer id={triggerId} data-test={triggerId}>
        <HamburgerMenuTrigger />
      </HamburgerMenuTriggerContainer>

      <NavbarLinksContainer id={linksId} data-test={linksId}>
        <NavbarLinks variant={variant} />
      </NavbarLinksContainer>

      <NavbarMenuContainer id={menusId} data-test={menusId}>
        <MenusWrapper>
          <NavbarMenus />
          <QuickActionsMenu />
        </MenusWrapper>
      </NavbarMenuContainer>
    </NavbarContainer>
  );
};
